<script lang="ts" setup>
import stores from '@jaaluu/stores';
import { t } from '@shared/i18n';

const props = defineProps({
  t_key: {
    required: true,
    type: String
  },
  width: {
    required: false,
    type: Number,
    default: 100
  }
});

const { nothingFound } = stores.assets.state;
</script>

<template>
  <div class="d-flex justify-center align-center flex-column mx-auto not-found-img">
    <v-img :width="`${props.width}px`" :src="nothingFound" />
    <div class="subtitle mt-2 text-center">{{ t(props.t_key) }}</div>
  </div>
</template>
